class FlagData {
  constructor(title, code) {
    this.title = title;
    this.code = code;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      flagDataId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      flagDataManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'کد', value: 'code', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchText: '',
      isActive: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن کدهای گوشی';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش کدهای گوشی';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getFlagDataFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.isActive = false;
      this.flagData = new FlagData('', '');
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addFlagDataFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش کدهای گوشی';
        this.$refs.confirm.text = 'از ویرایش کد گوشی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف کدهای گوشی';
        this.$refs.confirm.text = 'از حذف کد گوشی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addFlagDataFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editFlagDataFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteFlagDataFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.flagDataId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfFlagDatasWithPagination();
    },
    removeFilters: function () {
      this.searchText = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfFlagDatasWithPagination();
    },
    cancelSearch: function () {
      this.searchText = '';
      this.searchModal = false;
    },
  },
};
